import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

class ViewParameter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            noLinks: false,
        };


        this.dsd = new dsd();

        this.data = {};
        this.data.Parameter = null;

        if (this.props.Parameter){
            this.data.Parameter = this.props.Parameter; 
        }

        if (this.props.noLinks){
            this.state.noLinks = this.props.noLinks;
        }

        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.Parameter){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json,'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th>
                                <PD.Td>
                                    {(() => {
                                        switch (this.state.noLinks) {
                                            case true:
                                                return json.name
                                            default:
                                                return (
                                                    <PD.PdNavLink to={"/parameter/" + json._id} >
                                                        {json.name}
                                                    </PD.PdNavLink>
                                                )
                                        }
                                    })()}
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th><PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th><PD.Td>
                                    <PD.MdPresent>{json.proposals}</PD.MdPresent>
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'dataType') &&
                            <PD.Tr>
                                <PD.Th>Data Type</PD.Th><PD.Td>{json.dataType}</PD.Td>
                            </PD.Tr>
                        }

                        {json.dataType == 'lookup' &&
                            <PD.Tr>
                                <PD.Th>Permitted Values</PD.Th>
                                <PD.Td>
                                    <ul>
                                        {json.values.map(
                                            (value, pos) => 
                                            {
                                                return <li key={pos}>{value}</li>
                                            }
                                        )}
                                    </ul>
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'Interface') &&
                            <>
                                <PD.Tr>                                
                                    <PD.Th>Interface</PD.Th>
                                    <PD.Td>    
                                        <PD.PdNavLink to={"/interface/" + json.Interface._id} > {json.Interface.name}</PD.PdNavLink>
                                    </PD.Td>
                                </PD.Tr>

                                {json.Interface.Owner &&
                                    <PD.Tr>
                                        <PD.Th>Owner</PD.Th><PD.Td>{json.Interface.Owner.organisation}</PD.Td>
                                    </PD.Tr>
                                }
                            </>

                        }


                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.Parameter)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewParameter;